import { io } from "socket.io-client";

const getSocketUrl = () => {
  const hostname = window.location.hostname;
  const isLocalIP =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname) ||
    /^172\.(1[6-9]|2[0-9]|3[01])\./.test(hostname);

  if (isLocalIP) {
    return `${window.location.protocol}//${hostname}:5200`;
  }

  if (process.env.REACT_APP_BASE_URL) {
    return process.env.REACT_APP_BASE_URL;
  }
  return `${window.location.protocol}//${hostname}:5200`;
};

const socket = io(getSocketUrl(), {
  autoConnect: true,
  transports: ["polling", "websocket"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  secure: window.location.protocol === "https:",
});

socket.on("connect", () => {
  console.log("⚡ Real-time Socket connected:", socket.id);
});

socket.on("disconnect", () => {
  console.log("🔥 Real-time Socket disconnected");
});

export default socket;
